import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ReactSVG } from "react-svg";

import { useIntl } from 'react-intl';
import messages from '../messages';

import { useTheme } from '@mui/material/styles';
import { Box, Button, IconButton, Modal, TextField, Typography } from '@mui/material';
import { getStyles } from './styles';
import GeneralTable from '../../../../components/GeneralTable';
import { IconSvg } from '../../../../utils/globalIcons';
import { tostAlert } from '../../../../utils/AlertToast';
import LoadBar from '../../../../utils/LoadBar';
import ExtractionIntegrationsApi from '../../../../Api/Services/AppflyteBackend/ExtractionIntegrationApi';
import { useDispatch } from 'react-redux';
import { setExtractionIntegrationAdded } from '../../../../Redux/slice/newDataSlice';
import moment from 'moment';
import { getMainStyles } from '../../../../styles/styles';
import { Close } from '@mui/icons-material';
import { fetchSubscriptionId } from '../../../../utils/GetAccountDetails';

function ExtractionIntegrations({ dataLoading, connectors }) {
  const theme = useTheme();
  const styles = getStyles(theme);
  const mainStyles = getMainStyles(theme);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const intl = useIntl();

  const [loading, setLoading] = useState(false);
  const [authLoading, setAuthLoading] = useState(false);

  const modalDetails = { modalstatus: false, integration_data: null };
  const [modalData, setModalData] = useState(modalDetails);

  const handleIntegrationsDelete = async (item) => {
    try {

      const integration_name = item?.payload?.name;
      const integration_id = item?.payload?.__auto_id__;
      const extraction_triggerss = item.payload?.ameya_extraction_triggerss ?? [];

      const confirm = window.confirm(`${intl.formatMessage(messages.integration_remove_check)}: ${integration_name} ?`);
      if (!confirm) {
        return
      }

      setLoading(true)

      if ((extraction_triggerss || [])?.length > 0) {
        tostAlert(intl.formatMessage(messages.trigger_check), 'warning');
        return
      }

      const response = await ExtractionIntegrationsApi.delete(integration_id);
      if (response.status === 200) {
        tostAlert(intl.formatMessage(messages.integration_remove_success), 'success')
        dispatch(setExtractionIntegrationAdded(true))
      } else {
        tostAlert(intl.formatMessage(messages.integration_remove_error), 'error')
      }

    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false)
    }
  };

  const handleSelection = async (item) => {
    try {

      const integration_connector = item?.payload?.type;

      if (integration_connector === "aws_s3" || integration_connector === "webhook" || integration_connector === "azure_blob") {
        navigate(`/connectors/extraction-agent/connector-lists/add`, {
          state: {
            connection_type: integration_connector,
            connection_label: integration_connector,
            integration_data: item,
            action_type: 'put'
          }
        })
      } else {
        setModalData({ ...modalData, modalstatus: true, integration_data: item })
      }
    }
    catch (error) {
      console.log(error)
    }
  }

  const connectorNames = {
    google_drive: "Google Drive",
    one_drive: "One Drive",
    aws_s3: "AWS S3",
    webhook: "Webhook",
    gmail: "Gmail",
    outlook: "Outlook"
  };

  const editSupportedConnectors = ['google_drive', 'one_drive', 'gmail', 'outlook']

  const columns = [
    {
      id: 'payload.name',
      label: 'Name',
      sortable: true,
      renderCell: (row) => row?.payload?.name
    },
    {
      id: 'payload.type',
      label: 'Connector',
      sortable: true,
      renderCell: (row) =>
        <Box display={'flex'} alignItems={'center'}>
          <span style={{ marginRight: '10px' }}>
            <ReactSVG
              src={{
                google_drive: IconSvg.driveIcon,
                one_drive: IconSvg.onedriveIcon,
                gmail: IconSvg.mailIcon,
                outlook: IconSvg.mailIcon,
                webhook: IconSvg.apiIcon,
                aws_s3: IconSvg.awsIcon,
                azure_blob: IconSvg.azureBlobIcon
              }[row?.payload?.type]}
              beforeInjection={(svg) => {
                svg.setAttribute('style', 'width:24px; height:24px; display:block;');
                svg.setAttribute('stroke', '#0B51C5');
              }}
            />
          </span>
          <span>{connectorNames[row?.payload?.type] || row?.payload?.type}</span>
        </Box>
    },
    {
      id: 'payload.auth_status',
      label: 'Auth Status',
      sortable: true,
      renderCell: (row) => {
        const rawStatus = row?.payload?.auth_status ?? "valid";
        const status = rawStatus === "connected" ? "valid" : rawStatus;
        const formatted = status.charAt(0).toUpperCase() + status.slice(1);

        return (
          <Box display={'flex'} alignItems={'center'}>
            <span style={{ marginRight: '10px' }}>
              <ReactSVG
                src={{
                  Valid: IconSvg.trainedIcon,
                  Expired: IconSvg.errorIcon,
                }[formatted]}
                beforeInjection={(svg) => {
                  svg.setAttribute('style', 'width:24px; height:24px; display:block;');
                }}
              />
            </span>
            <span>{formatted}</span>
          </Box>
        );
      }
    },
    {
      id: 'payload.created_on',
      label: 'Created on',
      sortable: true,
      renderCell: (row) => moment(row?.payload?.created_on)?.format('DD-MMM-YYYY hh:mm A')
    },
    {
      id: '',
      label: '',
      sortable: false,
      renderCell: (row) =>
        <Box display={'flex'} alignItems={'center'}>

          <span style={{ marginRight: '10px' }} onClick={() => handleSelection(row)}>
            <ReactSVG
              src={IconSvg.editIcon}
              beforeInjection={(svg) => {
                svg.setAttribute('style', 'width:20px; height:20px; display:block;');
                svg.setAttribute('stroke', '#0B51C5');
              }}
            />
          </span>

          <span
            onClick={() => handleIntegrationsDelete(row)}
          >
            <ReactSVG
              src={IconSvg.deleteIcon}
              beforeInjection={(svg) => {
                svg.setAttribute('style', 'width:20px; height:20px; display:block;');
                svg.setAttribute('stroke', '#C30E2E');
              }}
            />
          </span>
        </Box>
    }
  ];

  const handleModalClose = () => {
    setModalData(modalDetails);
  }

  const typeConfig = {
    google_drive: { icon: IconSvg.driveIcon, label: "Google Drive" },
    one_drive: { icon: IconSvg.onedriveIcon, label: "Microsoft OneDrive" },
    gmail: { icon: IconSvg.mailIcon, label: "Gmail" },
    outlook: { icon: IconSvg.mailIcon, label: "Outlook" }
  };
  const currentType = typeConfig[modalData?.integration_data?.payload?.type];

  const waitForPopupMessage = (accept) => {
    return new Promise((resolve) => {
      const handler = (event) => {
        if (accept(event.data)) {
          window.removeEventListener('message', handler);
          resolve(event.data);
        }
      };
      window.addEventListener('message', handler);
    });
  };

  const handleConnectionIntegration = async () => {
    setAuthLoading(true)
    try {

      try {

        setModalData({ ...modalData, modalstatus: false })
        const subscriptionId = await fetchSubscriptionId();

        const appName = window.__ENV__.APP_NAME
        const auth_server_url = window.__ENV__.APPFLYTE_AUTHENTICATION_URL
        const origin_url = window.__ENV__.AMEYA_WEB_URL
        const integration_type = modalData?.integration_data?.payload?.type;

        const connectionTypeMap = { google_drive: "gdrive", one_drive: "onedrive", gmail: "gmail", outlook: "outlook" };
        const providerTypeMap = { google_drive: "google", one_drive: "azure", gmail: "google", outlook: "azure" };

        const service_type = connectionTypeMap[integration_type];
        const provider = providerTypeMap[integration_type];

        const response = await fetch(`${auth_server_url}/ameya_service/login`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            subscription_id: subscriptionId,
            app_name: appName,
            origin_url: origin_url,
            provider,
            service_type
          }),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        const { auth_url } = data;

        if (!auth_url) {
          throw new Error('No auth URL received from server');
        }

        const popup = window.open(auth_url, 'oauth_popup', 'width=600,height=600');
        if (!popup) {
          throw new Error('Popup was blocked. Please allow popups for this site.');
        }

        popup.focus();

        const popupMessagePromise = waitForPopupMessage((d) => d?.source === 'oauth-popup' && typeof d.user_id === 'string');
        const timeoutPromise = new Promise((_, reject) => {
          setTimeout(() => reject(new Error('OAuth timeout')), 60000);
        });

        const popupClosedPromise = new Promise((_, reject) => {
          const checkClosed = setInterval(() => {
            if (popup.closed) {
              clearInterval(checkClosed);
              reject(new Error('OAuth popup was closed'));
            }
          }, 1000);
        });

        const { user_id, user_mail, refresh_token } = await Promise.race([
          popupMessagePromise,
          timeoutPromise,
          popupClosedPromise
        ]);

        if (!popup.closed) {
          popup.close();
        }

        handleConnectionAuth(user_id, user_mail, refresh_token)
      } catch (error) {
        console.error('OAuth integration error:', error);

        if (error.message.includes('Popup was blocked')) {
          tostAlert(intl.formatMessage(messages.pop_up_block), 'error');
        } else if (error.message.includes('OAuth timeout')) {
          tostAlert(intl.formatMessage(messages.oauth_timeout), 'error');
        } else if (error.message.includes('OAuth popup was closed')) {
          tostAlert(intl.formatMessage(messages.oauth_cancel), 'info');
        } else {
          tostAlert(intl.formatMessage(messages.connector_update_error), 'error');
        }
        setModalData({ ...modalData, modalstatus: true });
      }
    } catch (error) {
      console.error('Integration error:', error);
      tostAlert(intl.formatMessage(messages.unexpected_error), 'error');
      setModalData({ ...modalData, modalstatus: true });
    } finally {
      setAuthLoading(false)
    }
  };

  const handleConnectionAuth = async (user_id, user_mail, refresh_token) => {
    if (loading) return
    setLoading(true)

    try {

      const integration_id = modalData?.integration_data?.payload?.__auto_id__;
      const update_key = modalData?.integration_data?.update_key

      const reqObj = {
        "id": integration_id,
        "fields": [
          { "path": "$.user_id", "value": user_id },
          { "path": "$.email", "value": user_mail },
          { "path": "$.refresh_token", "value": refresh_token },
          { "path": "$.auth_status", "value": "valid" },
          { "path": "$.updated_on", "value": moment().format('YYYY-MM-DD HH:mm:ss') }
        ]
      }

      const response = await ExtractionIntegrationsApi.update(JSON.stringify(reqObj), integration_id, update_key);
      if (response.status === 200) {
        tostAlert(intl.formatMessage(messages.connector_update_success), 'success')
        dispatch(setExtractionIntegrationAdded(true))
        handleModalClose();
      } else {
        tostAlert(intl.formatMessage(messages.connector_update_error), 'error')
      }

    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }


  return (
    <Box sx={styles.mainContainer}>
      <Box sx={styles.cardContainer}>
        {(loading || dataLoading || authLoading) && <LoadBar />}

        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>

          <Typography sx={styles.mainHeadingText}>Integrations</Typography>

          <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <Button
              onClick={() => navigate('/connectors/extraction-agent/connector-lists')}
              sx={{ backgroundColor: '#0B51C5', borderRadius: '20px', width: '160px' }}
            >
              <Typography sx={{ fontSize: '14px', fontWeight: '600', color: '#FFFFFF' }}>
                ADD INTEGRATION
              </Typography>
            </Button>
          </Box>
        </Box>

        <Box marginTop={'30px'} paddingBottom={'20px'}>
          <GeneralTable
            data={connectors}
            columns={columns}
            loading={loading || dataLoading}
          />
        </Box>
      </Box>

      <Modal open={modalData.modalstatus} onClose={handleModalClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
        <Box sx={mainStyles.modalcontainer}>

          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            {currentType && <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <ReactSVG
                src={currentType.icon}
                beforeInjection={(svg) => {
                  svg.setAttribute('style', 'width: 24px; height:24px; display: block;');
                  svg.setAttribute('stroke', '#0B51C5');
                }}
              />
              <Typography sx={{ fontSize: '16px', fontWeight: '600' }}>
                {currentType.label}
              </Typography>
            </Box>}
            <IconButton onClick={handleModalClose}>
              <Close />
            </IconButton>
          </Box>

          <Box marginTop={'10px'}>
            <Typography sx={{ fontSize: '14px', fontWeight: '600', marginBottom: '5px' }}>Integration Name</Typography>
            <TextField
              size='small'
              fullWidth
              disabled
              value={modalData?.integration_data?.payload?.name}
            />
          </Box>

          <Box sx={{ marginTop: '25px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Button
              onClick={() => handleConnectionIntegration()}
              sx={{ ...styles.integrateBtn, width: '130px' }}
              disabled={loading || authLoading}
            >
              <Typography sx={styles.integrateBtnText}>Authenticate</Typography>
            </Button>
          </Box>

        </Box>
      </Modal>

    </Box>
  )
}

export default ExtractionIntegrations;